import { FilesPresetForm } from "@pdfking/imposition-form"
import { PRINT_DESTINATION_ID } from "@pdfking/imposition/internal"
import { RecordByPrimaryKey } from "@pdfking/templates"

import { ImpositionPreset } from "./ImpositionPreset"
import type { Preset } from "./Preset"

// Short-key data matching Python make_data_for_size("35x50").
const imposition_data = () => ({
  component_array: [
    {
      padding: "1 mm",
      label: null,
      job_array: [
        {
          machine_size: "35x50",
          print_mode: "fr",
          margins: "7x3 mm",
          job_destination: PRINT_DESTINATION_ID,
        },
      ],
    },
  ],
  marking: [],
  quantity: 1,
})

const filecheck_data = () => ({
  component_array: [
    {
      padding: "5 mm",
    },
  ],
  marking: ["help"],
})

// No imposition at all: the uploaded pages are shown as they are, imposed from
// the file rows. Its form carries the job's name alone.
const files_preset = (id: string, name: string, emoji: string): Preset => ({
  id,
  name,
  emoji,
  data: {},
  hooks_list: {},
  material_list: [],
  build_form: FilesPresetForm,
})

/** The presets every host gets. A host with presets of its own spreads these
 * into its list — re-pushing them with its own `hooks_list`/`material_list` —
 * and hands the list to `ResolvePreset`. */
export const PresetList = RecordByPrimaryKey<Preset>([
  // First: it's the default, and the one you fall back to when no preset fits.
  files_preset("file", "PRESET_FILES", "📄"),
  ImpositionPreset({ id: "imposition", name: "IMPOSITION", emoji: "🖨️", data: imposition_data() }),
  ImpositionPreset({
    id: "filecheck",
    name: "FILECHECK",
    emoji: "✅",
    data: filecheck_data(),
    hidden_fields: ["quantity", "machine_size", "material", "filling", "flip", "subjects"],
  }),
])
